import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles(theme => ({
  scrollArea: {
    flexGrow: 1,
    padding: '0 12px',
    '& .ScrollbarsCustom-Content': {
      display: 'flex',
      flexDirection: 'column',
      '& > .MuiBox-root': {
        marginBottom: 10.5
      },
      '& > .MuiBox-root:first-child': {
        marginTop: 10.5
      }
    },
    '& .ScrollbarsCustom-Track': {
      right: [0, '!important'],
      width: [6, '!important']
    }
  },
  list: {
    opacity: 0,
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.standard,
      easing: theme.transitions.easing.easeInOut
    })
  },
  listVisible: {
    opacity: 1
  },
  bidList: {
    width: '100%'
  },
  scroll: {
    height: '100%',
    overflow: 'scroll'
  },
  bidsLoading: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(2)
  },
  loadingTypography: {
    marginBottom: theme.spacing(2)
  },
  noBidsTypography: {
    fontWeight: 'bold',
    opacity: 0.6,
    textAlign: 'center',
    padding: theme.spacing(2)
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/components/EngagementsBoard/ChatList/styles.js